import { ORIGINAL_DESTINATION_URL } from "./constants";
export const onSigninCallback = (navigate) => {
    const url = getTargetUrl();
    if (url) {
        clearTargetUrl();
        navigate(url, { replace: true });
    }
    else {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};
export const storeTargetUrl = () => window.sessionStorage.setItem(ORIGINAL_DESTINATION_URL, `${window.location.pathname}${window.location.hash}${window.location.search}`);
export const getTargetUrl = () => window.sessionStorage.getItem(ORIGINAL_DESTINATION_URL);
export const clearTargetUrl = () => window.sessionStorage.setItem(ORIGINAL_DESTINATION_URL, window.location.pathname);
//# sourceMappingURL=callback.js.map